import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const queryKey = ["estatePlan"] as const;

export function useInvalidateEstatePlan() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey });
  }, [queryClient]);
}
